module.exports = __webpack_public_path__ + "static/denichols-c731bd048815f2eec4965315d72d10e8.jpg";